/**
 * Styled footer component for vertical layout.
 * Based on Vuexy styled components.
 */

// Third-party Imports
import styled from '@emotion/styled';
import type { CSSObject } from '@emotion/styled';

// Config Imports
import themeConfig from '@configs/themeConfig';

// Util Imports
import { verticalLayoutClasses } from '@layouts/utils/layoutClasses';

type StyledFooterProps = {
  overrideStyles?: CSSObject;
};

const StyledFooter = styled.footer<StyledFooterProps>`
  display: flex;
  align-items: center;
  justify-content: center;
  inline-size: 100%;
  flex-shrink: 0;
  padding-block: 16px;

  &.${verticalLayoutClasses.footerFixed} {
    position: sticky;
    inset-block-end: 0;
    z-index: 10;
  }

  &.${verticalLayoutClasses.footerContentCompact} {
    .${verticalLayoutClasses.footerContentWrapper} {
      max-inline-size: ${themeConfig.compactContentWidth}px;
      margin-inline: auto;
      padding-inline: ${themeConfig.layoutPadding}px;
    }
  }

  &.${verticalLayoutClasses.footerContentWide} {
    .${verticalLayoutClasses.footerContentWrapper} {
      padding-inline: ${themeConfig.layoutPadding}px;
    }
  }

  .${verticalLayoutClasses.footerContentWrapper} {
    inline-size: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  ${({ overrideStyles }) => overrideStyles}
`;

export default StyledFooter;
